(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oyster-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oyster-editorial')) {
    customElements.define('oyster-editorial', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.control = this.querySelector('.oyster-editorial__playback');
        if (!this.video || !this.control) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = false;
        this.visible = false;
        this.video.controls = false;
        this.control.hidden = false;
        const update = () => {
          this.control.textContent = this.video.paused ? this.control.dataset.playLabel : this.control.dataset.pauseLabel;
        };
        this.control.addEventListener('click', () => {
          if (this.video.paused) {
            this.userPaused = false;
            this.video.play().catch(update);
          } else {
            this.userPaused = true;
            this.video.pause();
          }
        }, options);
        this.video.addEventListener('play', update, options);
        this.video.addEventListener('pause', update, options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.video.pause();
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.video.pause();
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (!this.visible) {
            this.video.pause();
          } else if (this.dataset.autoplay === 'true' && !this.motion.matches && !this.userPaused && !document.hidden) {
            this.video.play().catch(update);
          }
        }, { threshold: 0.2 });
        this.observer.observe(this);
        update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abortController?.abort();
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oyster-header"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('oyster-navigation'))customElements.define('oyster-navigation',class extends HTMLElement{
    connectedCallback(){
      this.abort=new AbortController();const signal=this.abort.signal;const menu=this.querySelector('details');const summary=menu.querySelector('summary');
      this.menu=menu;this.summary=summary;this.inertElements=[];this.cartRequest=0;
      const wrapper=this.closest('.page-wrapper');
      const update=()=>this.classList.toggle('is-scrolled',Math.max(window.scrollY,wrapper?.scrollTop||0)>20);update();window.addEventListener('scroll',update,{passive:true,signal});wrapper?.addEventListener('scroll',update,{passive:true,signal});
      menu.addEventListener('toggle',()=>this.syncMenu(),{signal});
      this.querySelector('.oy-menu__backdrop').addEventListener('click',()=>this.closeMenu(),{signal});
      document.addEventListener('keydown',event=>{
        if(!menu.open)return;
        if(event.key==='Escape'){
          event.preventDefault();
          const group=document.activeElement?.closest('.oy-menu__collection-group');
          if(group?.open&&menu.contains(group)){group.open=false;group.querySelector('summary')?.focus();return}
          this.closeMenu();return;
        }
        if(event.key!=='Tab')return;
        const focusable=this.menuFocusable();const first=focusable[0]||summary;const last=focusable.at(-1)||summary;
        if(!menu.contains(document.activeElement)||(event.shiftKey&&document.activeElement===first)||(!event.shiftKey&&document.activeElement===last)){
          event.preventDefault();(event.shiftKey?last:first).focus();
        }
      },{capture:true,signal});
      document.addEventListener('focusin',event=>{if(menu.open&&!menu.contains(event.target))summary.focus()},{signal});
      document.addEventListener('oyster:cart-change',()=>this.refreshCart(),{signal});
      this.querySelectorAll('.oy-menu__panel a').forEach(link=>link.addEventListener('click',()=>{
        const destination=new URL(link.href,window.location.href);
        if(destination.origin===window.location.origin&&destination.pathname===window.location.pathname&&destination.search===window.location.search){
          clearTimeout(this.closeTimer);this.closeTimer=setTimeout(()=>this.closeMenu(false),0);
        }
      },{signal}));
      this.syncMenu();
    }
    menuFocusable(){
      return [...this.menu.querySelectorAll('summary, a[href], button, input, select, textarea, [tabindex]')].filter(element=>!element.disabled&&element.tabIndex>=0&&!element.closest('[inert]')&&element.getClientRects().length&&getComputedStyle(element).visibility!=='hidden');
    }
    syncMenu(){
      this.classList.toggle('is-open',this.menu.open);
      if(!this.menu.open){this.restoreBackground();return}
      if(this.inertElements.length)return;
      (this.menuFocusable().find(element=>element!==this.summary)||this.summary).focus();
      for(let branch=this.menu;branch&&branch!==document.body;branch=branch.parentElement){
        for(const sibling of branch.parentElement?.children||[]){
          if(sibling===branch||sibling.hasAttribute('inert'))continue;
          sibling.setAttribute('inert','');this.inertElements.push(sibling);
        }
      }
    }
    restoreBackground(){
      this.inertElements?.forEach(element=>element.removeAttribute('inert'));this.inertElements=[];
    }
    closeMenu(restoreFocus=true){
      this.menu.open=false;this.syncMenu();if(restoreFocus)this.summary.focus();
    }
    async refreshCart(){
      const request=++this.cartRequest;const signal=this.abort.signal;
      try{
        const response=await fetch(this.dataset.cartUrl,{method:'GET',headers:{Accept:'application/json'},credentials:'same-origin',cache:'no-store',signal});
        if(!response.ok)return;
        const cart=await response.json();
        if(signal.aborted||request!==this.cartRequest||!Number.isSafeInteger(cart.item_count)||cart.item_count<0)return;
        const link=this.querySelector('[data-cart-link]');const count=link.querySelector('.oy-header__count');
        count.textContent=String(cart.item_count);count.hidden=cart.item_count===0;
        link.setAttribute('aria-label',cart.item_count?link.dataset.countLabel.replaceAll('__count__',String(cart.item_count)):link.dataset.emptyLabel);
      }catch{}
    }
    disconnectedCallback(){
      this.abort?.abort();clearTimeout(this.closeTimer);this.restoreBackground();
      if(this.menu)this.menu.open=false;this.classList.remove('is-open');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oyster-trade"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oyster-trade-inquiry')) {
    const inquiryProducts = new Map([
      ['Attune', 'attune'],
      ['Circadia', 'circadia'],
      ['Circadia — Wood / Oak', 'circadia'],
      ['Circadia — Wood / Ash', 'circadia'],
      ['Circadia — Wood / Walnut', 'circadia'],
      ['Circadia — Anodized aluminum / Clear', 'circadia'],
      ['Circadia — Anodized aluminum / Blue', 'circadia'],
      ['Impressions', 'impressions'],
      ['Impressions I — single-base table', 'impressions-i'],
      ['Impressions II — two-base table', 'impressions-ii'],
      ['Meditation Chair', 'meditation-chair'],
      ['Listening Chair', 'listening-chair'],
      ['Custom Furniture', 'custom-furniture'],
      ['Meditation Chair + Circadia bundle', 'meditation-circadia'],
      ['Listening Chair + Circadia bundle', 'listening-circadia']
    ]);
    const inquiryProductKeys = new Set(inquiryProducts.values());
    customElements.define('oyster-trade-inquiry', class extends HTMLElement {
      connectedCallback() {
        const form = this.querySelector('form');
        if (!form) return;

        this.abortController?.abort();
        this.abortController = new AbortController();
        const productInquiryView = this.dataset.inquiryView === 'oyster-product-inquiry';
        const listeningQuoteView = this.dataset.inquiryView === 'oyster-listening-quote';
        const storageKey = `oyster-trade-inquiry:${form.id}${listeningQuoteView ? ':listening-quote' : productInquiryView ? ':product' : ''}`;
        const response = this.querySelector('[data-form-state]');

        const analyticsKey = `${storageKey}:analytics-pending`;
        if (response?.dataset.formState === 'success') {
          this.trackConfirmedInquiry(analyticsKey);
        } else {
          form.addEventListener('submit', () => {
            const types = { 'Product enquiry': 'product', 'Project quotation': 'project', 'Dealership': 'dealer', 'Sales representation': 'representative' };
            const value = form.elements.namedItem('contact[Inquiry type]')?.value;
            const inquiryType = listeningQuoteView ? 'listening_quote' : types[value] || (productInquiryView ? 'product' : 'project');
            const inquiryProduct = listeningQuoteView ? 'listening-chair' : inquiryProducts.get(form.elements.namedItem('contact[Product or collection interest]')?.value);
            const pending = { inquiry_type: inquiryType, submitted_at: Date.now() };
            if (inquiryProduct) pending.inquiry_product = inquiryProduct;
            try {
              sessionStorage.setItem(analyticsKey, JSON.stringify(pending));
            } catch {}
          }, { signal: this.abortController.signal });
        }


        if (response?.dataset.formState === 'success') {
          try {
            sessionStorage.removeItem(storageKey);
          } catch {}
        } else if (listeningQuoteView) {
          this.initializeListeningQuote(form, response, storageKey);
        } else {
          const fields = Array.from(form.elements).filter((field) => (
            field.name?.startsWith('contact[') && field.type !== 'hidden'
          ));
          const inquiryType = form.elements.namedItem('contact[Inquiry type]');
          const inquiryTypes = { product: 'Product enquiry', project: 'Project quotation', dealer: 'Dealership', representative: 'Sales representation' };

          try {
            const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
            if (!this.inquiryInitialized && saved && typeof saved === 'object' && !Array.isArray(saved)) {
              fields.forEach((field) => {
                const savedInquiry = field === inquiryType && Object.values(inquiryTypes).includes(saved[field.name]);
                if ((!field.value || savedInquiry) && typeof saved[field.name] === 'string') {
                  field.value = saved[field.name];
                }
              });
            }
          } catch {}

          const params = new URLSearchParams(window.location.search);
          const freshEntry = !response && !this.inquiryInitialized;
          const requestedInquiry = params.get('inquiry');
          if (freshEntry && inquiryType && Object.hasOwn(inquiryTypes, requestedInquiry)) {
            inquiryType.value = inquiryTypes[requestedInquiry];
          }

          const projectSetting = form.elements.namedItem('contact[Project setting]');
          const sectorKeys = ['residential', 'corporate-wellness', 'education', 'fitness-wellness-facilities', 'healthcare', 'high-end-real-estate-developments', 'luxury-boutique-hospitality', 'military-first-responders', 'pro-sports-teams-performance-centers'];
          const sectorOptions = new Map(Array.from(projectSetting?.options || [])
            .filter((option) => sectorKeys.includes(option.dataset.sector))
            .map((option) => [option.dataset.sector, option.value]));
          const requestedSector = params.get('sector');
          if (freshEntry && !productInquiryView && projectSetting && sectorOptions.has(requestedSector)) {
            projectSetting.value = sectorOptions.get(requestedSector);
          }

          const updateProjectFields = () => {
            const isProject = inquiryType?.value === inquiryTypes.project;
            const isProduct = inquiryType?.value === inquiryTypes.product;
            this.querySelectorAll('[data-project-field]').forEach((group) => {
              group.hidden = !isProject;
              group.querySelectorAll('input, select, textarea').forEach((field) => {
                field.disabled = !isProject;
              });
            });
            this.querySelectorAll('[data-professional-field]').forEach((group) => {
              group.hidden = isProduct;
              group.querySelectorAll('input, select, textarea').forEach((field) => {
                field.disabled = isProduct;
              });
            });
          };
          updateProjectFields();
          inquiryType?.addEventListener('change', updateProjectFields, { signal: this.abortController.signal });

          const collectionNames = { attune: 'Attune', circadia: 'Circadia', impressions: 'Impressions', 'meditation-chair': 'Meditation Chair', 'listening-chair': 'Listening Chair', 'custom-furniture': 'Custom Furniture', 'meditation-circadia': 'Meditation Chair + Circadia bundle', 'listening-circadia': 'Listening Chair + Circadia bundle' };
          const requestedCollection = params.get('collection');
          const impressionPieces = { 'single-base-table': 'Impressions I — single-base table', 'two-base-table': 'Impressions II — two-base table' };
          const requestedPiece = params.get('piece');
          const circadiaFinishes = { finish_oak: 'Wood / Oak', finish_ash: 'Wood / Ash', finish_walnut: 'Wood / Walnut', finish_clear: 'Anodized aluminum / Clear', finish_blue: 'Anodized aluminum / Blue' };
          const requestedConfiguration = params.get('configuration');
          const productInterest = form.elements.namedItem('contact[Product or collection interest]');
          if (freshEntry && Object.hasOwn(collectionNames, requestedCollection) && productInterest) {
            productInterest.value = collectionNames[requestedCollection];
            if (requestedCollection === 'impressions' && Object.hasOwn(impressionPieces, requestedPiece)) {
              productInterest.value = impressionPieces[requestedPiece];
            }
            if (requestedCollection === 'circadia' && Object.hasOwn(circadiaFinishes, requestedConfiguration)) {
              productInterest.value += ' — ' + circadiaFinishes[requestedConfiguration];
            }
            if (inquiryType && !Object.hasOwn(inquiryTypes, requestedInquiry)) {
              inquiryType.value = productInquiryView ? inquiryTypes.product : inquiryTypes.project;
              updateProjectFields();
            }
          }
          this.inquiryInitialized = true;

          form.addEventListener('submit', () => {
            const values = Object.fromEntries(fields.map((field) => [field.name, field.value]));
            try {
              sessionStorage.setItem(storageKey, JSON.stringify(values));
            } catch {}
          }, { signal: this.abortController.signal });
        }

        if (response) requestAnimationFrame(() => response.focus());
      }

      trackConfirmedInquiry(analyticsKey) {
        let pending;
        try {
          pending = JSON.parse(sessionStorage.getItem(analyticsKey) || 'null');
          sessionStorage.removeItem(analyticsKey);
        } catch { return; }
        const types = ['product', 'project', 'dealer', 'representative', 'listening_quote'];
        if (!pending || !types.includes(pending.inquiry_type) || !Number.isFinite(pending.submitted_at)) return;
        const age = Date.now() - pending.submitted_at;
        if (age < 0 || age > 86400000) return;

        const publish = () => {
          if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
          const data = { inquiry_type: pending.inquiry_type };
          if (inquiryProductKeys.has(pending.inquiry_product)) data.inquiry_product = pending.inquiry_product;
          window.Shopify?.analytics?.publish?.('oyster:enquiry_submitted', data);
          if (typeof window.gtag !== 'function') {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function () { window.dataLayer.push(arguments); };
            const tag = document.createElement('script');
            tag.async = true;
            tag.src = 'https://www.googletagmanager.com/gtag/js?id=G-L0G9J4XHHX';
            document.head.append(tag);
            window.gtag('js', new Date());
            window.gtag('config', 'G-L0G9J4XHHX', { send_page_view: false });
          }
          window.gtag('event', 'generate_lead', {
            send_to: 'G-L0G9J4XHHX',
            ...data,
            page_location: window.location.origin + window.location.pathname
          });
        };
        if (window.Shopify?.customerPrivacy) {
          publish();
        } else {
          window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
            if (!error) publish();
          });
        }
      }

      initializeListeningQuote(form, response, storageKey) {
        const fields = Array.from(form.elements).filter((field) => (
          field.name?.startsWith('contact[') && field.type !== 'hidden'
        ));
        const configuration = form.elements.namedItem('contact[Listening Chair configuration]');
        const configurations = new Map(Array.from(configuration?.options || [])
          .filter((option) => ['chair-only', 'chair-ottoman'].includes(option.dataset.configuration))
          .map((option) => [option.dataset.configuration, option.value]));

        try {
          const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
          if (saved && typeof saved === 'object' && !Array.isArray(saved)) {
            fields.forEach((field) => {
              const value = saved[field.name];
              if (field.value || typeof value !== 'string') return;
              if (field === configuration && value && !Array.from(configurations.values()).includes(value)) return;
              field.value = value;
            });
          }
        } catch {}

        const requestedConfiguration = new URLSearchParams(window.location.search).get('configuration');
        if (!response && !this.quoteInitialized && configuration && configurations.has(requestedConfiguration)) {
          configuration.value = configurations.get(requestedConfiguration);
        }
        this.quoteInitialized = true;

        const save = () => {
          const values = Object.fromEntries(fields.map((field) => [field.name, field.value]));
          try {
            sessionStorage.setItem(storageKey, JSON.stringify(values));
          } catch {}
        };
        const options = { signal: this.abortController.signal };
        form.addEventListener('input', save, options);
        form.addEventListener('change', save, options);
        form.addEventListener('submit', save, options);
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
